import { useTranslation } from 'react-i18next';

import Alert from '../../../../../components/Alert';
import AlertButton from '../../../../../components/AlertButton';
import Tooltip from '../../../../../components/Tooltip';
import { i18nNS } from '../../../../../i18n';
import StopIcon from '../../../../../icons/StopIcon';
import useStopPoll from './vm';

const StopPoll = () => {
  const { t } = useTranslation([i18nNS.POLL, i18nNS.GLOSSARY]);

  const { canStopPoll, handleStopPoll } = useStopPoll();

  if (!canStopPoll) return null;

  return (
    <Tooltip title={t('stop_poll', { ns: i18nNS.POLL })}>
      <AlertButton
        variant="text"
        color="error"
        size="large"
        startIcon={<StopIcon aria-hidden />}
        onClick={handleStopPoll}
        aria-label={t('click_to_stop_poll', { ns: i18nNS.POLL })}
      >
        {t('stop_poll', { ns: i18nNS.POLL })}
        <Alert maxWidth="xs">
          <Alert.Header>{t('stop_poll', { ns: i18nNS.POLL })}</Alert.Header>
          <Alert.Body>
            {t(
              'to_avoid_confusion_and_surprised_groans_please_announce_to_the_class_that_you_re_going_to_stop_accepting_responses',
              { ns: i18nNS.POLL }
            )}
          </Alert.Body>
          <Alert.Footer>
            <Alert.Action
              variant="text"
              size="small"
              aria-label={t('click_to_cancel_stopping_poll', {
                ns: i18nNS.POLL,
              })}
            >
              {t('no', { ns: i18nNS.GLOSSARY })}
            </Alert.Action>
            <Alert.Action
              variant="contained"
              color="error"
              size="small"
              onClick={handleStopPoll}
              aria-label={t('click_to_stop_poll', { ns: i18nNS.POLL })}
            >
              {t('yes', { ns: i18nNS.GLOSSARY })}
            </Alert.Action>
          </Alert.Footer>
        </Alert>
      </AlertButton>
    </Tooltip>
  );
};

export default StopPoll;
